import React, { useEffect, useState } from "react";
import { getCsrfToken } from "../../../../public/api/authApi";
import { GlobalModal } from "../../../../global/GlobalModal";
import { GlobalButton } from "../../../../global/forms/GlobalFormFields";
import { deleteVisitor } from "../../api/visitorsApi";
import { ensureCsrfToken } from "../../utils/visitorHelpers";

export default function DeleteVisitorModal({ visitor, onClose, onSuccess, onError }) {
  const open = Boolean(visitor?.id);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) setLoading(false);
  }, [open, visitor?.id]);

  const handleConfirm = async () => {
    const visitorId = Number(visitor?.id);
    if (!Number.isFinite(visitorId) || visitorId <= 0) return;

    setLoading(true);
    try {
      const csrfToken = await ensureCsrfToken(getCsrfToken);
      await deleteVisitor(visitorId, csrfToken);
      onClose?.();
      onSuccess?.("Visitor deleted successfully");
    } catch (err) {
      onClose?.();
      onError?.(err?.message || "Failed to delete visitor");
    } finally {
      setLoading(false);
    }
  };

  return (
    <GlobalModal
      open={open}
      onClose={onClose}
      title="Delete visitor"
      description="This soft-deletes the visitor record."
      size="sm"
      closeOnBackdrop={!loading}
      footer={
        <div style={{ display: "flex", gap: "0.5rem", justifyContent: "flex-end", width: "100%" }}>
          <GlobalButton variant="ghost" onClick={onClose} disabled={loading}>
            Cancel
          </GlobalButton>
          <GlobalButton variant="danger" onClick={handleConfirm} disabled={loading}>
            {loading ? "Deleting…" : "Delete"}
          </GlobalButton>
        </div>
      }
    >
      <p style={{ fontSize: "0.9375rem", color: "#475569", lineHeight: 1.6 }}>
        Delete visitor{" "}
        <strong>{visitor?.visitor_name || visitor?.visitor_code}</strong>? This cannot be
        undone from the reception desk.
      </p>
    </GlobalModal>
  );
}
